export const slugConst = {
  label: 'Slug',
  maxLength: 255,
  pattern: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
  maxLengthMessage: 'El slug no puede exceder 255 caracteres',
  formatMessage:
    'Usa únicamente minúsculas, números y guiones entre palabras',
};
